import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './TabBar.css';

const navLinks = [
  { title: 'Home', path: '/', color: '#f3f4f6' },
  { title: 'Projects', path: '/projects', color: '#f3f4f6' },
  { title: 'About', path: '/about', color: '#f3f4f6' },
  { title: 'Contact', path: '/contact', color: '#f3f4f6' },
];

const TabBar = () => {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(navLinks.findIndex(link => link.path === location.pathname));
  const menuRef = useRef(null);
  const menuBorderRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      offsetMenuBorder(activeIndex);
      menuRef.current.style.setProperty("--timeOut", "none");
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [activeIndex]);

  const offsetMenuBorder = (index) => {
    const menu = menuRef.current;
    const activeItem = menu.querySelectorAll(".menu__item")[index];
    const menuBorder = menuBorderRef.current;
    const offsetActiveItem = activeItem.getBoundingClientRect();
    const left = Math.floor(offsetActiveItem.left - menu.offsetLeft - (menuBorder.offsetWidth - offsetActiveItem.width) / 2) + "px";
    menuBorder.style.transform = `translate3d(${left}, 0 , 0)`;
  };

  const handleClick = (index) => {
    if (activeIndex === index) return;
    setActiveIndex(index);
    if (navLinks[index].color) {
      document.body.style.backgroundColor = navLinks[index].color;
    }
    offsetMenuBorder(index);
  };

  useEffect(() => {
    document.body.style.backgroundColor = navLinks[activeIndex].color; // Set initial background color
    offsetMenuBorder(activeIndex);
  }, [activeIndex]);

  return (
    <div className="tab-bar-container">
      <menu className="menu" ref={menuRef}>
        {navLinks.map((link, index) => (
          <Link
            key={index}
            to={link.path}
            className={`menu__item ${activeIndex === index ? 'active' : ''}`}
            style={{ '--bgColorItem': link.color || '#4f46e5' }} // Default color for Home
            onClick={() => handleClick(index)}
          >
            {link.title}
          </Link>
        ))}
        <div className="menu__border" ref={menuBorderRef}></div>
      </menu>

      <div className="svg-container">
        <svg viewBox="0 0 202.9 45.5">
          <clipPath id="menu" clipPathUnits="objectBoundingBox" transform="scale(0.0049285362247413 0.021978021978022)">
            <path d="M6.7,45.5c5.7,0.1,14.1-0.4,23.3-4c5.7-2.3,9.9-5,18.1-10.5c10.7-7.1,11.8-9.2,20.6-14.3c5-2.9,9.2-5.2,15.2-7
              c7.1-2.1,13.3-2.3,17.6-2.1c4.2-0.2,10.5,0.1,17.6,2.1c6.1,1.8,10.2,4.1,15.2,7c8.8,5,9.9,7.1,20.6,14.3c8.3,5.5,12.4,8.2,18.1,10.5
              c9.2,3.6,17.6,4.2,23.3,4H6.7z"/>
          </clipPath>
        </svg>
      </div>
    </div>
  );
};

export default TabBar;
